import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import {AuthenticationService} from '../services/authentication/authentication.service';
import {User, UserRoles} from '../entities/user/user.entity';

@Injectable({
  providedIn: 'root'
})
export class NonSubscriberGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService,
  ) {}

  canActivate(): boolean {
    const user: User | null = this.authenticationService.getCurrentUser();
    if (user && user.isActive) {
      if (user.roles.includes(UserRoles.photographer)) {
        this.router.navigate(['/manage/dashboard']);
      } else {
        this.router.navigate(['/']);
      }
      return false;
    }
    return true;
  }
}
